// @ts-nocheck
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../runtime/json/scalar";
import { default as serialize, } from "../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        giftCodeType: "",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.giftCodeType !== undefined)
        result.giftCodeType = tsValueToJsonValueFns.string(value.giftCodeType);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.giftCodeType !== undefined)
        result.giftCodeType = jsonValueToTsValueFns.string(value.giftCodeType);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.giftCodeType !== undefined) {
        const tsValue = value.giftCodeType;
        result.push([1, tsValueToWireValueFns.string(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.giftCodeType = value;
    }
    return result;
}
